import DashboardConfig from './dashboard/DashboardConfig.js';
import UploadJob from './upload/uploadjob/UploadJobConfig.js';
import UploadJobDetails from './upload/uploadjobdetails/UploadJobDetailsConfig.js';
import CandidateSearch from './upload/candidatesearch/CandidateSearchConfig.js';
import MatchingResults from './upload/matchingdetails/MatchingDetailsConfig.js';
import CandidateChatbotConfig from './upload/Chatbot/CandidateChatbotConfig.js';
import MatchHistoryConfig from './upload/matchhistory/MatchHistoryConfig.js';
import ChatBotHistoryConfig from './upload/chatbothistory/ChatBotHistoryConfig.js';
import ManageJobConfig from './upload/managejobs/ManageJobConfig.js';
import ManageCandidatesConfig from './upload/managecandidates/ManageCandidatesConfig.js';
import ManageConsultantConfig from './upload/manageConsultant/ManageconsultantConfig.js';
import CandidateDetailsConfig from './upload/candidatedetails/CandidateDetailsConfig.js';
import JobDetailsConfig from './upload/Jobdetails/JobDetailsConfig.js'
import ConsultantProjectConfig from './upload/consultantProject/consultantProjectConfig.js'
/* Added the following code for POW-798.Dharma using AI Agent. April 1, 2026. Code Start */
import ManagePromptsConfig from './upload/manageprompts/ManagePromptsConfig.js';
/* Code end. Dharma using AI Agent. April 1, 2026 */
/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
import ManageOutsideCandidatesConfig from './upload/manageoutsidecandidates/ManageOutsideCandidatesConfig.js';
/* Code end. Harsha using AI Agent. July 9, 2026 */
/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
import ManagePartnerSubmissionsConfig from './upload/managepartners/ManagePartnerSubmissionsConfig.js';
/* Code end. Harsha using AI Agent. October 7, 2026 */
/* Added the following code for Istiyak using AI Agent. August 24, 2026. Code Start */
import RecruiterPerformanceConfig from './recruiterperformance/RecruiterPerformanceConfig.js';
/* Code end. Istiyak using AI Agent. August 24, 2026 */
/* Added the following code for Istiyak using AI Agent. October 22, 2026. Code Start */
import SourcingPerformanceConfig from './sourcingperformance/SourcingPerformanceConfig.js';
/* Code end. Istiyak using AI Agent. October 22, 2026 */
const recruiterConfigs = [
    DashboardConfig,
    UploadJob,
    UploadJobDetails,
    CandidateSearch,
    MatchingResults,
    CandidateChatbotConfig,
    MatchHistoryConfig,
    ChatBotHistoryConfig,
    ManageJobConfig,
    ManageCandidatesConfig,
    ManageConsultantConfig,
    CandidateDetailsConfig,
    JobDetailsConfig,
    ConsultantProjectConfig,
    /* Added the following code for POW-798.Dharma using AI Agent. April 1, 2026. Code Start */
    ManagePromptsConfig,
    /* Code end. Dharma using AI Agent. April 1, 2026 */
    /* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
    ManageOutsideCandidatesConfig,
    /* Code end. Harsha using AI Agent. July 9, 2026 */
    /* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
    ManagePartnerSubmissionsConfig,
    /* Code end. Harsha using AI Agent. October 7, 2026 */
    /* Added the following code for Istiyak using AI Agent. August 24, 2026. Code Start */
    RecruiterPerformanceConfig,
    /* Code end. Istiyak using AI Agent. August 24, 2026 */
    /* Added the following code for Istiyak using AI Agent. October 22, 2026. Code Start */
    SourcingPerformanceConfig
    /* Code end. Istiyak using AI Agent. October 22, 2026 */
]
export default recruiterConfigs;

